import React from "react";
import { register } from "swiper/element/bundle";
// import { slides } from "./data";
import { useSlideShows } from "../../../../hooks/apis/main";
register();

function Slider_index1() {
  const { data, isLoading, error } = useSlideShows();
  const slideshows = data?.slideshows || [];

  return (
    <div className="sliderIndex1">
      <swiper-container
        dir="rtl"
        autoplay="true"
        autoplay-delay="3000"
        effect="fade"
        slides-per-view="1"
        loop="true"
        speed="500"
        navigation-next-el=".next-btn"
        navigation-prev-el=".prev-btn"
      >
        {slideshows.map((slide) => {
          return (
            <swiper-slide key={slide.id}>
              <img
                src={slide.photo}
                className="img-fluid"
                alt={slide.title}
                title={slide.title}
                style={{ borderRadius: "50%", objectFit: "cover" }}
              />
            </swiper-slide>
          );
        })}
      </swiper-container>
      <div className="navigation">
        <div className="prev-btn">
          <i className="fas fa-angle-right"></i>
        </div>
        <div className="next-btn">
          <i className="fas fa-angle-left"></i>
        </div>
      </div>
    </div>
  );
}

export default Slider_index1;
